import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import { FaMicrophone } from "react-icons/fa6";
import React, { useState } from 'react';
import { IoMdClose } from "react-icons/io";
import { useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { HiMiniMagnifyingGlass } from "react-icons/hi2";
import { baseUrl } from '../config';
import styles from '../styles/nav.module.css';


const Dictaphone = () => {
    const [searchEmpty, setSearchEmpty] = useState(true);
    function setSearchbar(){
        try{
            if (inputRef.current.value !== "" || inputRef.current.defaultValue !== "") {
                setSearchEmpty(false);
            }else{
                setSearchEmpty(true);
            }
        }
        catch{}
    }
    const navigate = useNavigate();
    const inputRef = useRef();
    const {
        transcript,
        listening,
        resetTranscript,
        browserSupportsSpeechRecognition
    } = useSpeechRecognition();
  
    if (!browserSupportsSpeechRecognition) {
        return <span>Browser doesn't support speech recognition.</span>;
    }
    function Search(){
        var val = inputRef.current.value;
        if (val === 'home') {
            navigate('/');
        }
        else{
            navigate('/' + val);
        }
    }
    function clear() {
        resetTranscript();
        inputRef.current.value = "";
        setSearchbar();
    }
        return (
        <div id={styles.searchWrapper}>
            <form onSubmit={() => {Search()}} id={styles.search} name='searchForm'>
                <HiMiniMagnifyingGlass id={styles.searchIconInner}/>
                {listening ? <FaMicrophone id={styles.mic} style={{color:'#E9724C'}} onClick={() => {SpeechRecognition.stopListening(); Search();}}/> : <FaMicrophone id={styles.mic} onClick={SpeechRecognition.startListening}/>}
                <input ref={inputRef} type="text" placeholder="Search" id={styles.searchBar} defaultValue={transcript} name='search' onChange={setSearchbar}/>
                {searchEmpty !== true && <IoMdClose id={styles.clear} onClick={() => {clear()}}/>}
            </form>
        </div>
    );
  };
  export default Dictaphone;
